import { ContextMenuItem } from '@seen/ui'
import type { ReactNode } from 'react'
import { IconOpenInWindow } from '#src/components/icons/index.ts'
import { openInNewWindow } from '#src/utils/index.ts'

export interface ContextMenuOpenInNewWindowProps {
  href: string
}

export function ContextMenuOpenInNewWindow({
  href,
}: ContextMenuOpenInNewWindowProps): ReactNode {
  return (
    <ContextMenuItem className="gap-2" onSelect={() => openInNewWindow(href)}>
      <IconOpenInWindow className="-mt-px size-4 text-foreground-secondary" />
      Open in new window
    </ContextMenuItem>
  )
}
